import { Language } from '../Modules/Shared/Types/language.type';

export const I18N_UNAVAILABLE_MESSAGE: Record<Language, string> = {
  en: 'Something went wrong. Please refresh the page.',
  fr: "Une erreur s'est produite. Veuillez actualiser la page.",
};
